export default function StatCard({ label, value, icon: Icon, color = "#FFD700", testId }) {
  return (
    <div
      data-testid={testId}
      className="bg-surface gold-border rounded-2xl p-6 relative overflow-hidden transition-transform duration-200 hover:-translate-y-1"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="overline mb-2">{label}</p>
          <p
            className="font-display text-4xl md:text-5xl tracking-tight truncate"
            style={{ color }}
          >
            {value}
          </p>
        </div>
        {Icon && (
          <div
            className="w-10 h-10 rounded-full bg-void/60 flex items-center justify-center border shrink-0"
            style={{ borderColor: color + "40" }}
          >
            <Icon className="w-5 h-5" style={{ color }} strokeWidth={1.5} />
          </div>
        )}
      </div>
    </div>
  );
}
